import isNumber from 'lodash/isNumber';
import { LabelLayout } from './enum';
export const defaultLabelWidth = 100;
export const defaultLabelLayout = LabelLayout.horizontal;
export const defaultColumns = 1;
export const FIELD_SUFFIX = 'field';
export function normalizeLabelWidth(labelWidth, columns) {
    if (isNumber(labelWidth) || labelWidth === 'auto') {
        return new Array(columns).fill(labelWidth);
    }
    const labelWidths = new Array(columns).fill(defaultLabelWidth);
    labelWidth.slice(0, columns).forEach((width, index) => (labelWidths[index] = width));
    return labelWidths;
}
export function getProperty(props, key, dataSet, record) {
    if (props[key]) {
        return props[key];
    }
    const { name } = props;
    const field = dataSet && dataSet.getField(name);
    if (field) {
        const fieldProperty = field.get(key, record);
        if (fieldProperty) {
            return fieldProperty;
        }
    }
}
export const defaultExcludeUseColonTag = ['div', 'button', 'Button'];
export function hasParentElement(parentElement, tagName) {
    while (parentElement) {
        if (parentElement.tagName.toLowerCase() === tagName) {
            return true;
        }
        parentElement = parentElement.parentElement;
    }
    return false;
}
